package com.milta.core.localization.translations.sq

import com.milta.core.localization.HomeStrings

internal val Home = HomeStrings(
    navTournee = "Tur",
    navEcoDriving = "Eko vozitje",
    navCommunity = "Komunitet",
    navRewards = "Shpërblime",
    navHome = "Ballina",
    navRoutes = "Itineraret",
    navTeam = "Ekipi",
    navProfile = "Profili",
    navDashboard = "Dashboard",
)
